import Vue from 'vue';
import defaultState from './defaultState';
import * as C from '../../constants';

export default {
  [C.SKI_RESTECH_CLEAR_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region CHANNELS
  [C.SKI_RESTECH_CHANNEL_LOAD_PENDING](state) {
    Vue.set(state, 'xmlChannels', {
      ...state.xmlChannels,
      loading: true,
      error: undefined,
    });
  },

  [C.SKI_RESTECH_CHANNEL_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'xmlChannels', {
      ...state.xmlChannels,
      items: [],
      loading: false,
      error: payload,
    });
  },

  [C.SKI_RESTECH_CHANNEL_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'xmlChannels', {
      ...state.xmlChannels,
      items: payload,
      loading: false,
    });
  },

  [C.SKI_RESTECH_CHANNEL_CHANGE](state, payload) {
    Vue.set(state, 'xmlChannels', {
      ...state.xmlChannels,
      xmlChannel: payload,
    });
  },
  // endregion CHANNELS

  // region ADDONS
  [C.SKI_RESTECH_CHANNEL_ADDONS_LIST_PENDING](state) {
    Vue.set(state, 'addons', {
      ...state.addons,
      loading: true,
      error: undefined,
    });
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_LIST_FAILURE](state, payload) {
    Vue.set(state, 'addons', {
      ...state.addons,
      items: [],
      loading: false,
      error: payload,
    });
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_LIST_SUCCESS](state, payload) {
    Vue.set(state, 'addons', {
      ...state.addons,
      items: payload,
      loading: false,
    });
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_SEARCH](state, payload) {
    Vue.set(state, 'addons', {
      ...state.addons,
      search: payload,
    });
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_PENDING](state, id) {
    Vue.set(state.addons.update.inProgressItems, id, true);
    Vue.set(state.addons.update.errorItems, id, undefined);
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_SUCCESS](state, addon) {
    Vue.set(state.addons.items[addon.index], 'twentyExtraId', addon.twentyExtraId);
    Vue.set(state.addons.update.inProgressItems, addon.id, false);
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_FAILURE](state, payload) {
    Vue.set(state.addons.update.inProgressItems, payload.id, false);
    Vue.set(state.addons.updateErrorItems, payload.id, payload.error);
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_SHOW](state, addon) {
    Vue.set(state.addons, 'addon', {
      ...state.addons.addon,
      showProductNames: true,
      id: addon.id,
      description: addon.description,
      productNames: addon.productNames,
    });
  },

  [C.SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_CLOSE](state) {
    Vue.set(state.addons, 'addon', {
      ...state.addons.addon,
      showProductNames: false,
      id: undefined,
      description: undefined,
      productNames: [],
    });
  },
  // endregion ADDONS
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/restech/mutations.js